import { __decorate } from "tslib";
import StatusBadge from '@/components/StatusBadge.vue';
import TeamFilter from '@/components/TeamFilter.vue';
import { default as UserComponent } from '@/components/User.vue';
import ModalMixin from '@/mixins/modal-mixin';
import AppointmentViewModal from '@/Pages/Appointments/ViewModal.vue';
import CheckoutModal from '@/Pages/Sales/CheckoutModal.vue';
import debounce from 'lodash/debounce';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapActions, mapGetters, mapState } from 'vuex';
let AppointmentsTabComponent = class AppointmentsTabComponent extends Mixins(ModalMixin) {
    staffQuery = [];
    filter = 'upcoming';
    query = null;
    areDataLoading;
    findAppointmentsInStore;
    getTreatment;
    fetchAppointments;
    fetchServices;
    get params() {
        const defaultParams = {
            query: {
                $limit: 100,
                parentId: null,
                customerId: this.$route.params.id,
                $sort: {
                    startAt: -1
                }
            }
        };
        const today = this.$moment();
        if (!defaultParams.query)
            defaultParams.query = {};
        if (this.filter == 'previous') {
            defaultParams.query.startAt = { $lte: today };
        }
        else if (this.filter == 'upcoming') {
            defaultParams.query.startAt = { $gte: today };
        }
        if (this.query) {
            defaultParams.query.$or = [
                { notes: { $regex: this.query, $options: "i" } },
            ];
        }
        if (this.staffQuery.length) {
            defaultParams.query.services = { userId: { $in: this.staffQuery } };
        }
        return defaultParams;
    }
    get appointments() {
        const items = this.findAppointmentsInStore(this.params).data;
        items.forEach(item => {
            item.services.forEach((service) => {
                service.startAt = this.$moment(service.startAt);
                service.treatment = this.getTreatment(service.treatmentId);
            });
        });
        return items;
    }
    created() {
        this.fetchAppointments(this.params);
        this.fetchServices();
    }
    reloadAppointments(params) {
        debounce(() => {
            this.fetchAppointments(params);
        }, 200)();
    }
    newAppointment() {
        const appointment = {
            model: {
                customerId: this.$route.params.id,
            },
            _id: 'temp'
        };
        const { Appointment } = this.$FeathersVuex;
        new Appointment(appointment);
        this.openModal({ id: 'AppointmentFastModal' });
    }
};
__decorate([
    Watch('params')
], AppointmentsTabComponent.prototype, "reloadAppointments", null);
AppointmentsTabComponent = __decorate([
    Component({
        name: 'appointments',
        components: {
            StatusBadge,
            CheckoutModal,
            AppointmentViewModal,
            TeamFilter,
            UserComponent
        },
        computed: {
            ...mapState('appointment', { areDataLoading: 'isFindPending' }),
            ...mapGetters('appointment', { findAppointmentsInStore: 'find' }),
            ...mapGetters('treatment', { getTreatment: 'get' }),
        },
        methods: {
            ...mapActions('appointment', { fetchAppointments: 'find' }),
            ...mapActions('service', { fetchServices: 'find' }),
        }
    })
], AppointmentsTabComponent);
export default AppointmentsTabComponent;
